import React from 'react';
import inspirationBackground from '../assets/NYD-banner-hero.jpg';

function InspirationSection() {
  return (
    <section className="overflow-hidden">
      <img
        src={inspirationBackground}
        alt="Miles de aventuras a un click de distancia"
        className="w-full h-auto block"
      />
    </section>
  );
}

export default InspirationSection;